import axios from 'axios';

const gazetteerService = axios.create({
    baseURL: 'https://s0.anotatr.com',
    auth: {
        username: 'admin',
        password: '7ErdM[~SbGt$+.2!',
    },
});

export function saveToStaging() {
    return gazetteerService.post('/snapshot');
}

export function saveToProduction() {
    return gazetteerService.post('/deploy');
}

export function postGazetters(text, options = {}) {
    return axios({
        method: 'POST',
        url: 'https://s0.anotatr.com/annotate',
        data: { text, ...options },
    })
        .then(response => response)
        .catch(response => response);
}

export function saveGazetters(gazetters) {
    return axios({
        method: 'POST',
        url: '/api/v1/gazetters',
        data: gazetters,
        withCredentials: true,
    })
        .then(response => response)
        .catch(response => response);
}

export function loadGazetteerIndex() {
    return gazetteerService.get('/def');
}

export function saveGazetteerIndex(version, content) {
    return gazetteerService.put('/def', content, {
        params: {
            version,
        },
    });
}

export function loadGazetteer(filename, type) {
    return gazetteerService.get(`/lst/${filename}`);
}

export function saveGazetteer(filename, version, content) {
    return gazetteerService.put(`/lst/${filename}`, content, {
        headers: {
            'Content-Type': 'text/plain',
        },
        params: {
            version,
        },
    });
}


export function removeGazetteerDuplicates(filename) {
    return gazetteerService.post(`/lst/removeDuplicates/${filename}`, undefined);
}

export function syncFeaturesFromDb() {
    return gazetteerService.post('/syncFeatures', undefined);
}



// WEBPACK FOOTER //
// ./app/services/gazetters.js